let scriptParseEndtime: { [index: string]: number } = {};

export function addTime(key: string, value?: number) {
    scriptParseEndtime[key] = value || Date.now();
}

export function getTime(key: string) {
    return scriptParseEndtime[key];
}

export function test_resetTimes() {
    scriptParseEndtime = {};
}
